import React, { useEffect, useState, useContext } from "react";
import { useLocation, useParams, Outlet, useNavigate } from "react-router-dom";
import {
	ContentContainer,
	ContentGroup,
	ListItem,
	// QuestionDialog,
	Tariffable,
	Detail,
	createDialog,
} from "coaz-ui";
import {
	PiBook,
	PiUserPlus,
	PiProhibitLight,
	PiMoneyLight,
	PiPathLight,
	PiRadioButtonLight,
	PiGraduationCapLight,
} from "react-icons/pi";
import { GlobalContext } from "../contexts/GlobalContext";
import client from "../client";
import EditProgram from "./EditProgram";
import AddCpd from "./AddCpd";
import AddProgramStudent from "./AddProgramStudent";
import ContentColumn from "./ContentColumn";
import ContentRow from "./ContentRow";
import ContentRowItem from "./ContentRowItem";
import Card from "./Card";
import ResponsiveChildren from "./ResponsiveChildren";
// import UserItems from "./UserItems";

const PROGRAMS = "_programs";

const Program = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [program, setProgram] = useState(null);
	const [cpds, setCpds] = useState([]);
	const [students,setStudents] = useState([]);
	const [current, setCurrent] = useState(null);
	const [details, setDetails] = useState([]);
	const [buttons, setButtons] = useState([]);
	const [loading, setLoading] = useState(true);

	const { programId, cpdId } = useParams();
	const path = useLocation().pathname;
	const { request, getCurrent } = client;

	const navigate = useNavigate();

	const onOpenCpd = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		navigate(`${path}/_cpd/${id}`);
	}

	const onDeleteCpd = (e,id) => {

	}

	const onAddCpd = (e) => {
		e.preventDefault();
		createDialog({
			title: "Add CPD",
			Component: AddCpd,
			params: { programId: programId },
			version: version,
			setVersion: setVersion,
		});
	};

	const onAddStudent = (e) => {
		e.preventDefault();
		createDialog({
			title: "Add Student",
			Component: AddProgramStudent,
			params: { programId: programId },
			version: version,
			setVersion: setVersion,
		});
	};

	const getProgram = async () => {
		if (!programId) return;

		const curr = await getCurrent();

		if (!curr || !curr.user) return;
		setCurrent(curr);

		try {
			const response = await request("GET", `programs/${programId}`);

			if (response && response.ref) {
				setProgram(response);

				setButtons([
					{ 
						Icon: PiBook, 
						name: "Add CPD", 
						handler: onAddCpd },
					{
						Icon: PiUserPlus,
						name: "Add Student",
						handler: onAddStudent,
					},
				]);
			} else {
				setProgram(null);
			}
		} catch (error) {
			console.log(error);
			setProgram(null);
		}
	};

	const getStudents = async () => {
		try {
			const response = await request("GET", "students/by-program",null, {
				programId:programId
			});
			
			if(response && response.length > 0) {
				setStudents(response);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getCpds = async () => {

		try {
			const response = await request("GET", "cpds/by-program", null, {programId: programId,});
			
			if(response && response.length > 0) {
				setCpds(response);
			}
		} catch (error) {
			console.log(error);
			setCpds([]);
		}
	};

	const load = async () => {
		setLoading(true);
		await getProgram();
		await getCpds();
		await getStudents();
		setLoading(false);
	};

	useEffect(() => {
		load();
	}, [programId, version]);

	if (cpdId) return <Outlet />;

	return (
		<ContentContainer Icon={PiGraduationCapLight} text={`${program?.name ?? ""}`} scrollable={true} loading={loading}>
			{program && 
			<ContentColumn>
				<ContentRow>
					<ContentRowItem title={"Details"}>
						<div className="flex flex-col w-full h-auto p-2 space-y-2">
							<Detail
								Icon={PiProhibitLight}
								label="Reserved"
								value={program.reserved ? "Yes" : "No"}
							/>
							<Detail
								Icon={PiMoneyLight}
								label="Tariff Applicable"
								value={program.tariffApplicable ? "Yes" : "No"}
							/>
							{program.tariffApplicable &&
								program.criteriaPathItemId && (
									<Detail
										Icon={PiPathLight}
										label="Criteria Path"
										value={program.criteriaPathItemId}
									/>
							)}
						</div>
					</ContentRowItem>
					<ContentRowItem title={"Professional Categories"}>
						<div className="grid grid-cols-2 p-2 gap-2">
							{program.professionalCategories.map((category, i) => (
							<Detail
								key={i}
								Icon={PiRadioButtonLight}
								value={category}
							/>
						))}
						</div>
					</ContentRowItem>
				</ContentRow>
				<ContentGroup name={"Cpds"}>
					<ResponsiveChildren minGap={24}>
					{cpds.map((cpd, index) => (
						<Card
							key={cpd?.ref?.id ?? index}
							id={cpd?.ref?.id ?? index}
							heading={cpd?.name}
							body={cpd?.description}
							image={`${process.env.PUBLIC_URL}/images/cpd.jpg`}
							onOpen={onOpenCpd}
							actionText="Delete"
							onAction={onDeleteCpd}
						/>
					))}
					</ResponsiveChildren>
				</ContentGroup>
			</ContentColumn>
			}
		</ContentContainer>
	);

	/*return (
		<Tariffable
			tariffable={program}
			current={
				current
					? { ...current, authorities: current.authorities ?? [] }
					: null
			}
			request={request}
			errorMessage={client.errorMessage}
			EditTariffable={editDialog}
			version={version}
			setVersion={setVersion}
			buttons={path.includes(PROGRAMS) ? buttons : []}
			setButtons={addButtons}
			details={details}
			loading={loading}
			setLoading={setLoading}
		>
			{program?.description && (
				<ContentGroup name="Description">
					<p className="text-sm text-[rgb(68,71,70)] whitespace-pre-wrap">
						{program.description}
					</p>
				</ContentGroup>
			)}

			{path.includes(PROGRAMS) &&
				program?.professionalCategories?.length > 0 && (
					<ContentGroup name="Professional Categories">
						{program.professionalCategories.map((category, i) => (
							<ListItem
								key={i}
								Icon={PiRadioButtonLight}
								item={{ text: categoryName(category) }}
							/>
						))}
					</ContentGroup>
				)}

			{!path.includes(PROGRAMS) && !enrolled && (
				<ContentGroup name="CPDs">
					<p className="text-sm text-[rgb(68,71,70)]">
						Enroll in this program to see its CPDs.
					</p>
				</ContentGroup>
			)}

			{courses.length > 0 && (
				<ContentGroup name="CPDs">
					{courses.map((course, i) => (
						<CourseItem
							key={course.ref?.id ?? course.id ?? i}
							course={course}
						/>
					))}
				</ContentGroup>
			)}

			{path.includes(PROGRAMS) && (
        <ContentGroup name="Users">
          <UserItems
            key={programId}
            search={searchUsers}
            mapItem={(row) => row.student ?? row.user ?? row}
            buttons={userButtons}
            version={version}
          />
        </ContentGroup>
      )} 
		</Tariffable>
	);*/
};

export default Program;
